export const SUCCESS = "SUCCESS_USER";
export const ERROR = "ERROR_USER";
export const CLEAR = "CLEAR_USER";
export const LOADING = "LOADING_USER";

export const LOGGING = "LOGGING";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_USERS = "GET_USERS";

export function loading(loading = true) {
	return {
		type: LOADING,
		data: loading
	};
}

export function error(error) {
	return {
		type: ERROR,
		data: error
	};
}


export function success() {
	return {
		type: SUCCESS,
	};
}

export function clearCreator() {
	return {
		type: CLEAR
	};
}

export function logged(user) {
	return {
		type:LOGIN,
		data:user
	}
}

export function listUsers(users) {
	return {
		type:GET_USERS,
		data:users
	}
}